import { BrandBgEntity } from "@common/domain";
import { createAction, props } from "@ngrx/store";

export const brandBgCreateSuccess = createAction(
  "[Brand Bg] Create Success",
  props<{ brandBg: BrandBgEntity }>()
);

export const brandBgDeleteSuccess = createAction(
  "[Brand Bg] Delete Success",
  props<{ brandBg: BrandBgEntity }>()
);

export const brandBgUseSuccess = createAction(
  "[Brand Bg] Use Success",
  props<{ brandBg: BrandBgEntity }>()
);

export const brandBgUnUseSuccess = createAction(
  "[Brand Bg] Un Use Success",
  props<{ brandBg: BrandBgEntity }>()
);
